module.exports = __webpack_public_path__ + "static/nxrt-rail-cc13bab1a69e4b7be9864711abdb5145.jpg";